import React, { useContext } from 'react'
import { setStorage } from '../../../../utils/LocalStorage/LocalStorage'
import NavItem from '../NavItem/NavItem'
import UserThemeContext from '../../../../context/UserTheme'
import * as changeCase from 'change-case'

import './IconButtonGroup.scss'

const IconButtonGroup = () => {
  const [theme, setUserTheme, toggleTheme] = useContext(UserThemeContext)

  const iconButtons = [
    {
      id: 'github',
      type: 'icon',
      text: 'GitHub',
      tooltip: true,
      icon: { name: 'github', style: 'brands' },
      style: 'brands',
      alt: 'GitHub logo',
      href: 'https://github.com/jasoncardarelli',
    },
    {
      id: 'linkedin',
      type: 'icon',
      text: 'LinkedIn',
      tooltip: true,
      icon: { name: 'linkedin', style: 'brands' },
      style: 'brands',
      alt: 'LinkedIn logo',
      href: 'https://www.linkedin.com/in/jasoncardarelli',
    },
    {
      id: 'theme',
      type: 'icon',
      text: `${changeCase.capitalCase(toggleTheme(theme))} mode`,
      tooltip: true,
      icon: {
        name: 'circle-half-stroke',
        style: 'solid',
        alt: `${theme} mode`,
        size: 14,
        flipCondition: theme === 'light',
      },
      style: 'solid',
      alt: `${toggleTheme('uppercase')} mode`,
      action: () => {
        setUserTheme(toggleTheme(theme))
        setStorage('userTheme', toggleTheme(theme))
      },
    },
  ]

  return (
    <div className='icon-button-group'>
      {iconButtons.map((btn) => {
        return (
          <NavItem
            key={btn.id}
            id={btn.id}
            type={btn.type}
            text={btn.text}
            tooltip={btn.tooltip}
            href={btn.href}
            action={btn.action}
            icon={btn.icon}
          />
        )
      })}
    </div>
  )
}

export default IconButtonGroup
